import { createContext } from "react";

export const SuperadminBillsHistoryContext = createContext();
